import { Injectable } from '@angular/core';
import { Observable, map, mergeMap, Subject, of, BehaviorSubject } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BroadcastNotificationsService } from './data/broadcast-notifications.service';

interface BroadcastDocument {
  notification: { id: string };
  timestamp: string;
}

@Injectable({
  providedIn: 'root',
})
export class BroadcastUtilsService {
  private broadcastUpdate: Subject<void> = new Subject<void>();
  public broadcastUpdate$ = this.broadcastUpdate.asObservable();

  private readonly _currentNotificationIdSource = new BehaviorSubject<string>('');
  readonly currentNotificationId$ = this._currentNotificationIdSource.asObservable();

  constructor(private afs: AngularFirestore, private broadcastService: BroadcastNotificationsService) {}

  public listenForBroadcast(lang: string): Observable<{ body: string } | null> {
    return this.afs
      .collection('broadcasts', (ref) => ref.orderBy('timestamp', 'desc').limit(1))
      .valueChanges()
      .pipe(
        map((doc) => doc[0] as BroadcastDocument),
        mergeMap((doc) => {
          if (doc?.notification) {
            this._setcurrentNotificationId(doc.notification.id);
            return this.broadcastService.getBroadcastNotification(doc.notification.id, lang);
          }
          this.removeNotificationId();
          return of(null);
        })
      );
  }

  public refreshBroadcastListener(): void {
    this.broadcastUpdate.next();
  }

  private _setcurrentNotificationId(notificationId: string): void {
    this._currentNotificationIdSource.next(notificationId);
  }

  removeNotificationId(): void {
    this._setcurrentNotificationId('');
  }
}
